import { type ENV, MfeConfig } from '@carvana/microfrontend';
import { MfeReact } from '@carvana/microfrontend-react';
import { getHeaderManifest } from '@carvana/header';

export const QUALI_CDN_PATH = 'carvana-quali-ui';
export const QUALI_MODULE = 'QualiModule';

const config = () =>
  MfeConfig({
    name: 'tradesUi',
    Render: MfeReact(),
    ENV: process.env.CARVANA_APP_MFE_ENV as ENV,
    globals: {
      'prop-types': () => import('prop-types'),
      'styled-components': () => import('styled-components'),
      axios: () => import('axios'),
      Axios: () => import('axios'),
      JSXRuntime: () => import('react/jsx-runtime'),
      PropTypes: () => import('prop-types'),
      React: () => import('react'),
      ReactDOM: () => import('react-dom'),
      ReactRouterDom: () => import('react-router-dom'),
      StyledComponents: () => import('styled-components'),
      datadog: () => import('@datadog/browser-rum'),
      styled: () => import('styled-components')
    },
    files: [
      [
        'FooterModule',
        [
          {
            component: 'default',
            browser: true,
            default: {
              file: 'index.js',
              manifest: `${
                process.env.CARVANA_APP_CDN_URL
              }/footer/module/assets-manifest.json?v=${Date.now()}`
            }
          }
        ]
      ],
      [
        'HeaderModule',
        [
          {
            component: 'default',
            default: {
              file: 'index.js',
              manifest: getHeaderManifest(process.env.CARVANA_APP_ENVIRONMENT)
            }
          }
        ]
      ],
      [
        QUALI_MODULE,
        [
          {
            component: 'default',
            local: {
              file: 'index.js',
              manifest: `http://localhost:2006/assets-manifest.json?v=${Date.now()}`
            },
            css: {
              files: ['index.css']
            },
            default: {
              file: 'index.js',
              manifest: `${
                process.env.CARVANA_APP_STATIC_PUBLIC_URL
              }/${QUALI_CDN_PATH}/assets-manifest.json?v=${Date.now()}`
            }
          }
        ]
      ]
    ]
  });

export default config;
